/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { useFeatures } from '@/hooks/useFeatures';
import { FiberOutgoingTable } from '../../../-components/FiberOutgoingTable';
import { useFiberOutgoingList } from '../../../-hooks/useFiberOutgoingList';

export const Route = createFileRoute(
  '/(client)/transactions/(pages)/(list)/outgoing/',
)({
  component: OutgoingTransactionsPage,
});

function OutgoingTransactionsPage() {
  const listState = useFiberOutgoingList();
  const { isFeatureEnabled } = useFeatures();
  const canImportOutgoing = isFeatureEnabled('outgoing-transaction-upload');

  return (
    <FiberOutgoingTable
      listState={listState}
      canImportOutgoing={canImportOutgoing}
    />
  );
}
